var _ = require('underscore');

var React = require("react");
const createReactClass = require("create-react-class");

var VariableTable = require('../../deploynaut/js/variable_table.jsx');
var VariableEditor = require('../../deploynaut/js/variable_editor.jsx');

/**
 * Variables provides a UI for displaying and editing environment variables. The main state is held here,
 * and displayed via VariableTable. Data is copied into the VariableEditor for editing, and copied back
 * if VariableEditor's save is successful.
 */
var Variables = createReactClass({

	modelToArray: function(model) {
		return _.map(_.keys(model), function(key) {
			return {
				variable: key,
				value: model[key]
			};
		});
	},

	getInitialState: function() {
		return {
			editing: false,
			Variables: this.modelToArray(this.props.model.Variables),
			VariablesNeedFullDeploy: this.props.model.VariablesNeedFullDeploy,
			SecurityID: this.props.model.InitialSecurityID,
			message: { type: 'success', body: '' }
		};
	},

	startEditing: function() {
		this.setState({
			editing: true
		});
	},

	editingSubmit: function(variables) {
		// Convert the data back into associative array expected by the backend.
		var assocArray = {};
		for (var i=0; i<variables.length; i++) {
			assocArray[variables[i].variable] = variables[i].value;
		}

		var self = this;
		return Q($.ajax({
			type: "POST",
			url: this.props.model.FormAction,
			data: {
				Details: JSON.stringify(assocArray),
				DispatcherSecurityID: this.state.SecurityID
			}
		}))
			.then(function(data) {
				self.setState({
					editing: false,
					Variables: self.modelToArray(data.Variables),
					VariablesNeedFullDeploy: data.VariablesNeedFullDeploy,
					SecurityID: data.NewSecurityID,
					message: { type: 'success', body: data.Message }
				});
			})
			.fail(function(data) {
				self.setState({
					message: { type: 'danger', body: "Failed to save changes: " + data.responseText }
				});
			});

	},

	editingCancel: function() {
		this.setState({
			editing: false
		});
	},

	render: function() {
		var message = '';
		if (this.state.message.body) {
			message = (
				<div className="variables">
					<div className={'alert alert-'+this.state.message.type} dangerouslySetInnerHTML={{__html:this.state.message.body}} />
				</div>
			);
		}

		var deployNeededMessage = null;
		if (this.state.VariablesNeedFullDeploy) {
			deployNeededMessage = (
				<div className="alert alert-warning"
					dangerouslySetInnerHTML={{__html:this.props.model.FullDeployNeededMessage}} />
			);
		}

		if (!this.state.editing) {
			return (
				<div className="variables">
					{message}
					{deployNeededMessage}
					<VariableTable
						variables={this.state.Variables}
						edit={this.startEditing}
						/>
				</div>
			);

		} else {
			return (
				<div className="variables">
					{message}
					{deployNeededMessage}
					<VariableEditor
						variables={this.state.Variables}
						blacklist={this.props.model.Blacklist}
						submit={this.editingSubmit}
						cancel={this.editingCancel}
						/>
				</div>
			);
		}
	}
});


module.exports = Variables;
